<template lang="pug">
div
  v-row.mb-0.mt-2.romaneio-cards-row
    v-col(v-for="card in dashboardCards", :key="card.label")
      v-card.pa-3.white--text(
        elevation="0",
        outlined,
        :style="{ backgroundColor: card.color, height: '110px', borderRadius: '18px 6px 18px 6px', cursor: card.temAbertura ? 'pointer' : 'default' }",
        @mouseup="card.temAbertura && abrirDetalheCard(card)"
      )
        .caption.font-weight-bold.text-uppercase {{ card.label }}
        .font-weight-bold.my-1(:class="card.valueClass") {{ card.value }}
        .caption(v-if="card.subtitle") {{ card.subtitle }}

  v-row.mt-0
    v-col(cols="12", md="8")
      v-card.panel-card.mb-4(outlined)
        .panel-card__header
          span.panel-card__title Período de análise
        v-card-text.panel-card__content
          v-row(align="center", justify="center", no-gutters)
            v-col.mr-4(cols="auto")
              v-alert(
                type="warning",
                dense,
                outlined,
                shaped,
                style="margin-bottom: 0; max-width: 250px; font-size: 12px; line-height: 1.3; background-color: #fffde7 !important"
              ) As datas impactam somente os gráficos de barra horizontal.
            v-col(cols="auto")
              v-text-field(
                v-model="dataInicial",
                label="Data inicial",
                type="date",
                outlined,
                dense,
                hide-details,
                style="min-width: 180px"
              )
            v-col.ml-4(cols="auto")
              v-text-field(
                v-model="dataFinal",
                label="Data final",
                type="date",
                outlined,
                dense,
                hide-details,
                style="min-width: 180px"
              )
            v-col.ml-4(cols="auto")
              v-btn(
                color="primary",
                @click="buscarDashboard",
                :loading="carregandoDashboard"
              )
                v-icon(left) mdi-magnify
                span Buscar

      v-card.panel-card(outlined)
        .panel-card__header
          span.panel-card__title Bases origem com mais romaneios para integração - (Total: {{ totalOrigemRomaneios }} Romaneios )
          v-btn.panel-card__expand.monitorsys-action-button(
            outlined,
            small,
            @click="dialogs.origem = true"
          )
            v-icon(small) mdi-arrow-expand
        v-card-text.panel-card__content
          apexchart(
            v-if="chartOrigemSeries[0].data.length > 0",
            type="bar",
            :options="chartOrigemOptions",
            :series="chartOrigemSeries",
            height="275"
          )
          .panel-card__empty(v-else, style="height: 275px")
            span Nenhum dado encontrado para o período selecionado.

    v-divider.d-none.d-md-block(:inset="true", vertical)

    v-col(cols="12", md="4")
      v-card.panel-card(outlined)
        .panel-card__header
          span.panel-card__title Romaneios disponibilizados (últimos 7 dias) - (Total: {{ totalUlimos7DiasRomaneios }} Romaneios )
          v-btn.panel-card__expand.monitorsys-action-button(
            outlined,
            small,
            @click="dialogs.diario = true"
          )
            v-icon(small) mdi-arrow-expand
        v-card-text.panel-card__content
          apexchart(
            v-if="chartDisponibilizadosSeries[0].data.length > 0",
            type="bar",
            :options="chartDisponibilizadosOptions",
            :series="chartDisponibilizadosSeries",
            height="400"
          )
          .panel-card__empty(v-else, style="height: 400px")
            span Nenhum dado encontrado para o período selecionado.

    //- Gráfico Destino
    v-row.mt-0
      v-col.d-flex.flex-column(cols="12", md="12")
        v-card.panel-card.mb-4(outlined)
          .panel-card__header
            span.panel-card__title Bases destino que mais receberam romaneios integrados - (Total: {{ totalDestinoRomaneios }} Romaneios )
            v-btn.panel-card__expand.monitorsys-action-button(
              outlined,
              small,
              @click="dialogs.destino = true"
            )
              v-icon(small) mdi-arrow-expand
          v-card-text.panel-card__content
            apexchart(
              v-if="chartDestinoSeries[0].data.length > 0",
              type="bar",
              :options="chartDestinoOptions",
              :series="chartDestinoSeries",
              height="280"
            )
            .panel-card__empty(v-else, style="height: 280px")
              span Nenhum dado encontrado para o período selecionado.

  //- Expanded dialogs - Gráfico Origem
  v-dialog(
    :value="dialogs.origem",
    @input="dialogs.origem = $event",
    content-class="romaneio-dialog-content",
    max-width="1200px",
    width="1200px"
  )
    v-card.panel-dialog
      .panel-card__header.panel-card__header--dialog
        span.panel-card__title Bases origem com mais romaneios para integração - (Total: {{ totalOrigemRomaneios }} Romaneios )
        v-btn(icon, small, @click="dialogs.origem = false")
          v-icon(small) mdi-close
      v-card-text.panel-card__dialog-content.pa-2.pl-4
        apexchart(
          v-if="chartOrigemSeriesFull[0] && chartOrigemSeriesFull[0].data.length",
          type="bar",
          :options="chartOrigemOptionsFull",
          :series="chartOrigemSeriesFull",
          height="480"
        )
        .panel-card__empty(v-else)
          span Nenhum dado encontrado para o período selecionado.

  //- Expanded dialogs - Gráfico Destino
  v-dialog(
    :value="dialogs.destino",
    @input="dialogs.destino = $event",
    content-class="romaneio-dialog-content",
    max-width="1200px",
    width="1200px"
  )
    v-card.panel-dialog
      .panel-card__header.panel-card__header--dialog
        span.panel-card__title Bases destino que mais receberam romaneios integrados - (Total: {{ totalDestinoRomaneios }} Romaneios )
        v-btn(icon, small, @click="dialogs.destino = false")
          v-icon(small) mdi-close
      v-card-text.panel-card__dialog-content.pa-2.pl-4
        apexchart(
          v-if="chartDestinoSeriesFull[0] && chartDestinoSeriesFull[0].data.length",
          type="bar",
          :options="chartDestinoOptionsFull",
          :series="chartDestinoSeriesFull",
          height="480"
        )
        .panel-card__empty(v-else)
          span Nenhum dado encontrado para o período selecionado.

  //- Expanded dialogs - Gráfico Diário
  v-dialog(
    :value="dialogs.diario",
    @input="dialogs.diario = $event",
    content-class="romaneio-dialog-content",
    max-width="1200px",
    width="1200px"
  )
    v-card.panel-dialog
      .panel-card__header.panel-card__header--dialog
        span.panel-card__title Romaneios disponibilizados (últimos 7 dias) - (Total: {{ totalUlimos7DiasRomaneios }} Romaneios )
        v-btn(icon, small, @click="dialogs.diario = false")
          v-icon(small) mdi-close
      v-card-text.panel-card__dialog-content.pa-2.pl-4
        apexchart(
          v-if="chartDisponibilizadosSeries[0] && chartDisponibilizadosSeries[0].data.length > 0",
          type="bar",
          :options="chartDisponibilizadosOptions",
          :series="chartDisponibilizadosSeries",
          height="480"
        )
        .panel-card__empty(v-else)
          span Nenhum dado encontrado para o período selecionado.

  v-dialog(v-model="dialog.aberto", max-width="1200", scrollable)
    v-card
      v-card-title.white--text.pa-2.pl-4(
        :style="{ backgroundColor: dialog.cor }"
      )
        span {{ dialog.titulo }}
        v-spacer
        v-btn(
          icon,
          dark,
          @click="dialog.aberto = false",
          style="width: 32px; height: 32px"
        )
          v-icon(small) mdi-close
      v-card-text.pb-2.pt-2.pr-2.mr-0(
        style="display: flex; justify-content: flex-end"
      )
        v-text-field(
          v-model="dialog.pesquisa",
          append-icon="mdi-magnify",
          label="Pesquisar",
          single-line,
          hide-details,
          outlined,
          dense,
          clearable,
          style="max-width: 300px"
        )
      v-data-table.dialog-abertura-table(
        :headers="dialog.colunas",
        :items="dialog.itens",
        :search="dialog.pesquisa",
        :items-per-page="5",
        :footer-props="footProps",
        fixed-header,
        no-data-text="Nenhum registro encontrado",
        dense
      )
</template>

<script>
import { mapMutations } from "vuex";
import { integracao as api } from "@/api";

export default {
  name: "DashboardRomaneio",

  data: () => ({
    aberturaCardBaseDestino: [],
    aberturaCardBaseOrigem: [],
    aberturaCardEmpresaDestino: [],
    aberturaCardEmpresaOrigem: [],

    dashboardCards: [
      {
        id: "ttl_clientes_origem",
        label: "Origens",
        value: 0,
        valueClass: "text-h4",
        subtitle: "BASE DE DADOS",
        color: "#247a8a",
        temAbertura: true,
      },
      {
        id: "ttl_clientes_destino",
        label: "Destinos",
        value: 0,
        valueClass: "text-h4",
        subtitle: "BASE DE DADOS",
        color: "#7a9630",
        temAbertura: true,
      },
      {
        id: "ttl_empresas_origem",
        label: "Empresas Origem",
        value: 0,
        valueClass: "text-h4",
        subtitle: "CNPJ/CPF",
        color: "#8e62b9",
        temAbertura: true,
      },
      {
        id: "ttl_empresas_destino",
        label: "Empresas Destino",
        value: 0,
        valueClass: "text-h4",
        subtitle: "CNPJ/CPF",
        color: "#c57030",
        temAbertura: true,
      },
      {
        id: "ttl_ultima_mov",
        label: "Última movimentação",
        value: "",
        valueClass: "text-h5",
        subtitle: null,
        color: "#30518e",
        temAbertura: false,
      },
      {
        id: "ttl_romaneios",
        label: "Romaneios Integrados",
        value: 0,
        valueClass: "text-h4",
        subtitle: null,
        color: "#9e3a45",
        temAbertura: false,
      },
    ],

    dialogs: {
      origem: false,
      destino: false,
      diario: false,
    },

    dialog: {
      aberto: false,
      titulo: "",
      cor: "#247a8a",
      itens: [],
      colunas: [],
      pesquisa: "",
    },

    dataInicial: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000)
      .toISOString()
      .slice(0, 10),
    dataFinal: new Date().toISOString().slice(0, 10),
    carregandoDashboard: false,

    footProps: {
      itemsPerPageOptions: [50, 100, 200, 300, 500, -1],
      showCurrentPage: true,
      showFirstLastPage: true,
      itemsPerPageAllText: "Todos",
      itemsPerPageText: "Itens por página",
    },

    chartOrigemSeries: [
      { name: "Ativos", data: [] },
      { name: "Estornados", data: [] },
    ],
    chartOrigemSeriesFull: [
      { name: "Ativos", data: [] },
      { name: "Estornados", data: [] },
    ],
    chartOrigemOptionsFull: {
      chart: { type: "bar", toolbar: { show: false }, stacked: true },
      plotOptions: {
        bar: { horizontal: true, barHeight: "75%", borderRadius: 3 },
      },
      colors: ["#8b1a2e", "#e57373"],
      dataLabels: {
        enabled: true,
        style: { fontSize: "12px", colors: ["#fff"] },
        formatter: (val) => (val > 0 ? val.toLocaleString("pt-BR") : ""),
      },
      legend: { show: true, position: "top" },
      xaxis: { categories: [], labels: { style: { fontSize: "11px" } } },
      yaxis: { labels: { maxWidth: 200, style: { fontSize: "11px" } } },
      grid: { borderColor: "#f1f1f1" },
      tooltip: { enabled: false },
    },
    chartOrigemOptions: {
      chart: { type: "bar", toolbar: { show: false }, stacked: true },
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: "75%",
          borderRadius: 3,
        },
      },
      colors: ["#8b1a2e", "#e57373"],
      dataLabels: {
        enabled: true,
        style: { fontSize: "12px", colors: ["#fff"] },
        formatter: (val) => (val > 0 ? val.toLocaleString("pt-BR") : ""),
      },
      legend: { show: true, position: "top" },
      xaxis: {
        categories: [],
        labels: { style: { fontSize: "11px" } },
      },
      yaxis: {
        labels: {
          maxWidth: 200,
          style: { fontSize: "11px" },
        },
      },
      grid: { borderColor: "#f1f1f1" },
      tooltip: { enabled: false },
    },

    chartDestinoSeries: [
      { name: "Ativos", data: [] },
      { name: "Estornados", data: [] },
    ],
    chartDestinoSeriesFull: [
      { name: "Ativos", data: [] },
      { name: "Estornados", data: [] },
    ],
    chartDestinoOptionsFull: {
      chart: { type: "bar", toolbar: { show: false }, stacked: true },
      plotOptions: {
        bar: { horizontal: true, barHeight: "75%", borderRadius: 3 },
      },
      colors: ["#1a7a6e", "#80cbc4"],
      dataLabels: {
        enabled: true,
        style: { fontSize: "12px", colors: ["#fff"] },
        formatter: (val) => (val > 0 ? val.toLocaleString("pt-BR") : ""),
      },
      legend: { show: true, position: "top" },
      xaxis: { categories: [], labels: { style: { fontSize: "11px" } } },
      yaxis: { labels: { maxWidth: 200, style: { fontSize: "11px" } } },
      grid: { borderColor: "#f1f1f1" },
      tooltip: { enabled: false },
    },
    chartDestinoOptions: {
      chart: { type: "bar", toolbar: { show: false }, stacked: true },
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: "75%",
          borderRadius: 3,
        },
      },
      colors: ["#1a7a6e", "#80cbc4"],
      dataLabels: {
        enabled: true,
        style: { fontSize: "12px", colors: ["#fff"] },
        formatter: (val) => (val > 0 ? val.toLocaleString("pt-BR") : ""),
      },
      legend: { show: true, position: "top" },
      xaxis: {
        categories: [],
        labels: { style: { fontSize: "11px" } },
      },
      yaxis: {
        labels: {
          maxWidth: 200,
          style: { fontSize: "11px" },
        },
      },
      grid: { borderColor: "#f1f1f1" },
      tooltip: { enabled: false },
    },

    chartDisponibilizadosSeries: [
      { name: "Ativos", data: [] },
      { name: "Estornados", data: [] },
    ],
    chartDisponibilizadosOptions: {
      chart: { type: "bar", toolbar: { show: false }, stacked: true },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "70%",
          borderRadius: 3,
        },
      },
      colors: ["#1a56b0", "#90caf9"],
      dataLabels: {
        enabled: true,
        style: { fontSize: "11px", colors: ["#fff"] },
        formatter: (val) => (val > 0 ? val.toLocaleString("pt-BR") : ""),
      },
      legend: { show: true, position: "top" },
      xaxis: {
        categories: [],
        labels: { style: { fontSize: "11px" } },
      },
      yaxis: {
        labels: { style: { fontSize: "11px" } },
      },
      grid: { borderColor: "#f1f1f1" },
      tooltip: { enabled: false },
    },

    totalOrigemRomaneios: 0,
    totalDestinoRomaneios: 0,
    totalUlimos7DiasRomaneios: 0,
  }),

  methods: {
    ...mapMutations("loader", ["showLoader", "hideLoader"]),

    async buscarDashboard() {
      if (isNaN(new Date(this.dataInicial).getTime())) {
        this.$toast.error("Data inicial inválida");
        return;
      }

      if (isNaN(new Date(this.dataFinal).getTime())) {
        this.$toast.error("Data final inválida");
        return;
      }

      if (this.dataInicial > this.dataFinal) {
        this.$toast.error(
          "A data inicial deve ser menor ou igual à data final"
        );
        return;
      }

      this.showLoader();
      this.carregandoDashboard = true;
      this.limparGraficos();
      try {
        api.refreshAuthProd(this.$store.state.auth);

        const resultado = await api.getDashboardRomaneiosClientes(
          this.dataInicial,
          this.dataFinal
        );

        this.totalOrigemRomaneios = resultado.graficoOrigem
          .reduce(
            (sum, item) =>
              sum + item.ttl_romaneios + (item.ttl_romaneios_estornados || 0),
            0
          )
          .toLocaleString("pt-BR");

        this.totalDestinoRomaneios = resultado.graficoDestino
          .reduce(
            (sum, item) =>
              sum + item.ttl_romaneios + (item.ttl_romaneios_estornados || 0),
            0
          )
          .toLocaleString("pt-BR");

        this.totalUlimos7DiasRomaneios = resultado.graficoDiario
          .reduce(
            (sum, item) =>
              sum + item.ttl_romaneios + (item.ttl_romaneios_estornados || 0),
            0
          )
          .toLocaleString("pt-BR");

        this.preencheCards(resultado.cards[0]);
        this.preencheGraficoDestino(resultado.graficoDestino);
        this.preencheGraficoOrigem(resultado.graficoOrigem);
        this.preencheGraficoDiario(resultado.graficoDiario);

        const chavesAbertura = [
          "aberturaCardBaseDestino",
          "aberturaCardBaseOrigem",
          "aberturaCardEmpresaDestino",
          "aberturaCardEmpresaOrigem",
        ];

        chavesAbertura.forEach((chave) => {
          this[chave] = this.formatarItensAbertura(resultado[chave]);
        });
      } catch (error) {
        console.error("Erro ao buscar dados do dashboard:", error);
        this.$toast.error("Erro ao buscar dados do dashboard");
      } finally {
        this.carregandoDashboard = false;
        this.hideLoader();
      }
    },

    limparGraficos() {
      const seriesVazia = () => [
        { name: "Ativos", data: [] },
        { name: "Estornados", data: [] },
      ];
      this.chartOrigemSeries = seriesVazia();
      this.chartOrigemSeriesFull = seriesVazia();
      this.chartOrigemOptions.xaxis.categories = [];
      this.chartOrigemOptionsFull.xaxis.categories = [];
      this.chartDestinoSeries = seriesVazia();
      this.chartDestinoSeriesFull = seriesVazia();
      this.chartDestinoOptions.xaxis.categories = [];
      this.chartDestinoOptionsFull.xaxis.categories = [];
      this.chartDisponibilizadosSeries = seriesVazia();
      this.chartDisponibilizadosOptions.xaxis.categories = [];
      this.totalOrigemRomaneios = 0;
      this.totalDestinoRomaneios = 0;
      this.totalUlimos7DiasRomaneios = 0;
    },

    preencheCards(data) {
      if (!data) return;

      const campoMap = {
        ttl_clientes_origem: "ttl_clientes_origem",
        ttl_clientes_destino: "ttl_clientes_destino",
        ttl_empresas_origem: "ttl_empresas_origem",
        ttl_empresas_destino: "ttl_empresas_destino",
        ttl_ultima_mov: "ultima_mov",
        ttl_romaneios: "ttl_romaneios",
      };

      this.dashboardCards = this.dashboardCards.map((card) => {
        const campo = campoMap[card.id];
        if (campo === undefined) return card;

        if (card.id === "ttl_ultima_mov") {
          const d = new Date(data[campo]);
          const dia = d.getDate();
          const mes = d
            .toLocaleString("pt-BR", { month: "short" })
            .replace(".", "");
          const ano = d.getFullYear();
          const hora = d.toLocaleString("pt-BR", {
            hour: "2-digit",
            minute: "2-digit",
          });
          return { ...card, value: `${dia} ${mes} ${ano} ${hora}` };
        }

        return { ...card, value: data[campo].toLocaleString("pt-BR") };
      });
    },

    preencheGraficoDestino(data) {
      if (!data) data = [];
      const top5 = data.slice(0, 5);
      this.chartDestinoSeries = [
        { name: "Ativos", data: top5.map((i) => i.ttl_romaneios) },
        {
          name: "Estornados",
          data: top5.map((i) => i.ttl_romaneios_estornados || 0),
        },
      ];
      this.chartDestinoOptions.xaxis.categories = top5.map((i) => i.nome);
      this.chartDestinoSeriesFull = [
        { name: "Ativos", data: data.map((i) => i.ttl_romaneios) },
        {
          name: "Estornados",
          data: data.map((i) => i.ttl_romaneios_estornados || 0),
        },
      ];
      this.chartDestinoOptionsFull.xaxis.categories = data.map((i) => i.nome);
    },

    preencheGraficoOrigem(data) {
      if (!data) data = [];
      const top5 = data.slice(0, 5);
      this.chartOrigemSeries = [
        { name: "Ativos", data: top5.map((i) => i.ttl_romaneios) },
        {
          name: "Estornados",
          data: top5.map((i) => i.ttl_romaneios_estornados || 0),
        },
      ];
      this.chartOrigemOptions.xaxis.categories = top5.map((i) => i.nome);
      this.chartOrigemSeriesFull = [
        { name: "Ativos", data: data.map((i) => i.ttl_romaneios) },
        {
          name: "Estornados",
          data: data.map((i) => i.ttl_romaneios_estornados || 0),
        },
      ];
      this.chartOrigemOptionsFull.xaxis.categories = data.map((i) => i.nome);
    },

    preencheGraficoDiario(data) {
      if (!data) data = [];
      const formatarDia = (iso) => {
        const [, mes, dia] = iso.split("-");
        return `${dia}/${mes}`;
      };
      this.chartDisponibilizadosSeries = [
        { name: "Ativos", data: data.map((i) => i.ttl_romaneios) },
        {
          name: "Estornados",
          data: data.map((i) => i.ttl_romaneios_estornados || 0),
        },
      ];
      this.chartDisponibilizadosOptions.xaxis.categories = data.map((i) =>
        formatarDia(i.movimentacao)
      );
    },

    abrirDetalheCard(card) {
      const colunasVolume = [
        {
          text: "Cargas",
          value: "cargas",
          sortable: true,
          align: "end",
          width: 120,
        },
        {
          text: "Toneladas",
          value: "peso_kg",
          sortable: true,
          align: "end",
          width: 140,
        },
        {
          text: "Sacas",
          value: "sacas",
          sortable: true,
          align: "end",
          width: 120,
        },
      ];

      const colunasClientes = [
        { text: "Descrição", value: "nome", sortable: true },
        ...colunasVolume,
      ];

      const colunasEmpresasOrigem = [
        { text: "Base origem", value: "nome", sortable: true },
        {
          text: "ID",
          value: "idempresa",
          sortable: true,
          align: "end",
          width: 120,
        },
        { text: "Razão Social", value: "razao_empresa", sortable: true },
        ...colunasVolume,
      ];

      const colunasEmpresasDestino = [
        { text: "Base destino", value: "nome", sortable: true },
        {
          text: "ID",
          value: "idempresa",
          sortable: true,
          align: "end",
          width: 120,
        },
        { text: "Razão Social", value: "razao_empresa", sortable: true },
        ...colunasVolume,
      ];

      const mapaCard = {
        ttl_clientes_origem: {
          titulo: "Origens - Detalhamento",
          itens: this.aberturaCardBaseOrigem,
          colunas: colunasClientes,
        },
        ttl_clientes_destino: {
          titulo: "Destinos - Detalhamento",
          itens: this.aberturaCardBaseDestino,
          colunas: colunasClientes,
        },
        ttl_empresas_origem: {
          titulo: "Empresas Origem - Detalhamento",
          itens: this.aberturaCardEmpresaOrigem,
          colunas: colunasEmpresasOrigem,
        },
        ttl_empresas_destino: {
          titulo: "Empresas Destino - Detalhamento",
          itens: this.aberturaCardEmpresaDestino,
          colunas: colunasEmpresasDestino,
        },
      };

      const config = mapaCard[card.id];
      if (!config) return;

      this.dialog.titulo = config.titulo;
      this.dialog.itens = config.itens;
      this.dialog.colunas = config.colunas;
      this.dialog.cor = card.color;
      this.dialog.pesquisa = "";
      this.dialog.aberto = true;
    },

    formatarItensAbertura(items) {
      if (!items || items.length === 0) return [];
      return items.map((item) => ({
        ...item,
        cargas: item.cargas.toLocaleString("pt-BR"),
        peso_kg: this.utilFormatarTon(item.peso_kg),
        sacas: this.utilFormatarSC(item.peso_kg),
      }));
    },

    utilFormatarTon(valor) {
      const num = parseFloat(valor);
      if (isNaN(num)) return valor;
      const tons = num / 1000;
      return tons.toLocaleString("pt-BR", { maximumFractionDigits: 2 });
    },

    utilFormatarSC(valor) {
      const num = parseFloat(valor);
      if (isNaN(num)) return valor;
      const sacas = num / 60;
      return (
        sacas.toLocaleString("pt-BR", { maximumFractionDigits: 0 }) + " sc"
      );
    },
  },

  watch: {},

  mounted() {
    this.buscarDashboard();
  },
};
</script>

<style>
.panel-card {
  border-color: #d9e2ef !important;
  box-shadow: 0 2px 6px rgba(15, 42, 77, 0.08) !important;
  border-radius: 18px 6px 18px 6px !important;
}

.romaneio-cards-row {
  margin-left: -4px !important;
  margin-right: -4px !important;
}

.romaneio-cards-row > [class*="col-"],
.romaneio-cards-row > .col {
  padding: 4px !important;
}

.panel-card--tall {
  min-height: 560px;
  height: 100%;
}

.panel-card__header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 16px 16px 0;
}

.panel-card__title {
  color: #0a1f44;
  font-size: 15px;
  font-weight: 700;
}

.panel-card__expand {
  height: 30px !important;
  min-width: 36px !important;
  padding: 0 8px !important;
}

.panel-card__content {
  padding: 8px 16px 16px !important;
}

.dialog-abertura-table .v-data-table__wrapper {
  height: calc(90vh - 180px);
  overflow-y: auto;
}

.panel-dialog {
  border-color: #d9e2ef !important;
  border-radius: 10px !important;
  box-shadow: 0 2px 6px rgba(15, 42, 77, 0.08);
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 100%;
  overflow: hidden;
}

.panel-card__header--dialog {
  flex: 0 0 auto;
  padding: 16px;
}

.panel-card__dialog-content {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}

.panel-card__empty {
  align-items: center;
  color: #5f6b7a;
  display: flex;
  height: 100%;
  justify-content: center;
  min-height: 320px;
  text-align: center;
}

.romaneio-dialog-content.v-dialog {
  margin: 24px auto;
  height: calc(100vh - 48px);
  max-height: calc(100vh - 48px);
}
</style>
